import API from "@aws-amplify/api";

const FOLDER_PACKAGING_JOB_PROPS = `
  jobId
  status
  personId
  accountId
  projectId
  folderName
  classification
  itemCount
  totalBytes
  manifestKey
  rawPrefix
  finalFileKey
  fullFinalFileKey
  componentId
  outputSize
  errorCode
  errorMessage
  createdAt
  updatedAt
`;

const START_FOLDER_PACKAGING = `
  mutation StartFolderPackaging($input: FolderPackagingStartInput!) {
    StartFolderPackaging(input: $input) {
      ${FOLDER_PACKAGING_JOB_PROPS}
    }
  }
`;

const GET_FOLDER_PACKAGING_JOB = `
  query GetFolderPackagingJob($jobId: ID!, $personId: ID!, $accountId: String!) {
    GetFolderPackagingJob(jobId: $jobId, personId: $personId, accountId: $accountId) {
      ${FOLDER_PACKAGING_JOB_PROPS}
    }
  }
`;

function makeFolderPackagingRequest(query, variables) {
  return API.graphql({
    query,
    variables,
    authMode: "AWS_IAM",
  });
}

export async function startFolderPackaging(input) {
  const response = await makeFolderPackagingRequest(START_FOLDER_PACKAGING, {
    input,
  });
  return response.data.StartFolderPackaging;
}

export async function getFolderPackagingJob({ jobId, personId, accountId }) {
  const response = await makeFolderPackagingRequest(GET_FOLDER_PACKAGING_JOB, {
    jobId,
    personId,
    accountId,
  });
  return response.data.GetFolderPackagingJob;
}
